import { Modal, Table } from 'antd';
import { useStatusLegendQuery, StatusLegendEntry } from '../../redux/api/kit-staging';

interface Props {
	open: boolean;
	onClose: () => void;
}

export function StatusLegendPopup({ open, onClose }: Props) {
	const { data, isLoading } = useStatusLegendQuery(undefined, { pollingInterval: 10000 });
	return (
		<Modal open={open} onCancel={onClose} title="Status Legend" footer={null} width={720} destroyOnClose>
			<Table<StatusLegendEntry>
				rowKey="status"
				loading={isLoading}
				dataSource={data ?? []}
				pagination={false}
				columns={[
					{ title: 'Status', dataIndex: 'label', key: 'label' },
					{ title: 'Description', dataIndex: 'description', key: 'description' },
				]}
			/>
		</Modal>
	);
}
